/**
 * EL SI Y EL NO DEL CONSENTIMIENTO, CON LA MISMA REGLA QUE WHATSAPP (CONSENT-UN-SOLO-SI-T1).
 *
 * AUDIENCIA: el cliente nuevo en el chat del enlace publico.
 *
 * DE DONDE SALE. El chat decidia el consentimiento OBLIGATORIO (Ley 1581) con
 * una regla que solo miraba el COMIENZO de la respuesta. Medido el 15-sep sobre
 * lo servido: -sinceramente no-, -sin datos-, -okey no-, -claro que no- y
 * -siempre no- contaban como SI (5 de 9 negativas). Y WhatsApp aceptaba otras
 * palabras. Ares decidio (#15158): UNA regla, en la API, comparacion EXACTA
 * contra una lista; lo que no calce, se repregunta.
 *
 * LA LISTA LA SIRVE LA API en GET /api/businesses/config, bloque consentimiento
 * {afirmativos, negativos, normalizacion} (Argy-A, #15168). Si la API todavia no
 * lo trae, el chat usa la lista de la decision #15158 tal cual. NUNCA vuelve al
 * -empieza por-.
 *
 * Sin DOM: lo prueba scripts/check-consentimiento.mjs.
 */

/** La lista de la decision de Ares #15158, para cuando la API no trae el bloque. */
export const LISTA_DECISION_15158 = {
  afirmativos: ['si', 's', 'yes', 'claro', 'dale', 'ok', 'okey', 'listo', 'correcto', 'acepto', 'de acuerdo', 'esta bien', '👍', '✅'],
  negativos: ['no', 'n', 'nel', 'no acepto', 'esta mal', 'corregir']
};

/**
 * LOS 8 SIGNOS que la API vuelve espacio, y NINGUNO MAS (Consentimiento.cs de
 * NexoAPI, rama argy-api/consent-un-solo-si c0eab5b). Comillas, guiones o
 * parentesis NO: una respuesta con comillas no calza y se repregunta, igual que
 * en WhatsApp.
 */
export const SIGNOS_A_ESPACIO = ['.', ',', '!', '?', '¡', '¿', ';', ':'];

/**
 * Normaliza EXACTO como Consentimiento.Normalizar de la API, paso por paso:
 * (a) nulo o solo espacios -> vacio; (b) minusculas; (c) descomponer y quitar
 * toda marca diacritica (categoria Mn, no solo el rango de tildes); (d) quitar el
 * selector de variacion U+FE0F y los tonos de piel U+1F3FB..U+1F3FF; (e) los 8
 * signos a espacio; (f) recomponer, partir SOLO por espacio sin vacios y unir con
 * un espacio. Mismo resultado para la misma frase en el chat y en WhatsApp.
 */
export function normalizar(texto) {
  const s = String(texto === null || texto === undefined ? '' : texto);
  if (s.trim() === '') return '';
  let t = s.toLowerCase().normalize('NFD');
  t = t.replace(/\p{Mn}/gu, '');
  t = t.replace(/️/g, '').replace(/[\u{1F3FB}-\u{1F3FF}]/gu, '');
  t = Array.from(t).map((c) => (SIGNOS_A_ESPACIO.includes(c) ? ' ' : c)).join('');
  return t.normalize('NFC').split(' ').filter((p) => p !== '').join(' ');
}

/**
 * Las reglas desde el config. Recibe el CUERPO de GET business-config (o null).
 * fuente: 'api' | 'decision-15158'.
 */
export function reglasDelConsentimiento(config) {
  const b = config && (config.consentimiento || config.Consentimiento);
  const af = b && Array.isArray(b.afirmativos) ? b.afirmativos : null;
  const ne = b && Array.isArray(b.negativos) ? b.negativos : null;
  if (af && af.length && ne && ne.length) {
    return { afirmativos: af.map(normalizar), negativos: ne.map(normalizar), fuente: 'api' };
  }
  return {
    afirmativos: LISTA_DECISION_15158.afirmativos.map(normalizar),
    negativos: LISTA_DECISION_15158.negativos.map(normalizar),
    fuente: 'decision-15158'
  };
}

/** 'si' | 'no' | 'no-entendido'. Comparacion EXACTA de la respuesta entera. */
export function clasificar(texto, reglas) {
  const t = normalizar(texto);
  if (!t) return 'no-entendido';
  if (reglas.negativos.includes(t)) return 'no';
  if (reglas.afirmativos.includes(t)) return 'si';
  return 'no-entendido';
}

/**
 * LOS CONSENTIMIENTOS QUE SE PREGUNTAN HOY (ONB-DIAN-PARAMETRO-T1).
 *
 * La factura electronica se ofrece SOLO si la API lo dice: llave
 * facturacion_electronica_ofrecida en la raiz de GET business-config (A #15415 y
 * #15419). Hoy viene en false porque el servicio no existe, y la API descarta ese
 * consentimiento si llega. Solo un true la enciende: si la llave no llega, no se
 * pregunta, que es el lado seguro.
 */
export function consentimientosQueAplican(consentimientos, ofreceFactura) {
  const lista = Array.isArray(consentimientos) ? consentimientos : [];
  return ofreceFactura === true ? lista : lista.filter((c) => c.field !== 'consentFacturaElectronica');
}

export const REPREGUNTA =
  'No te entendí. Para esta pregunta respóndeme solo SÍ o NO, por favor 🙏';
